import useHackathon from '@/data/hook/hackathon/useHackathon';
import { ROUTES } from '@/utils/routes';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { LEI_FELCA } from '@/lib/growthbook';
import { ComponentType } from 'react';
import { Navigate } from 'react-router-dom';

const withLeiFelca = <P extends object>(Component: ComponentType<P>) => {
  const Wrapper = (props: P) => {
    const isLeiFelca = useFeatureIsOn(LEI_FELCA);
    const { isFinish, isLoading } = useHackathon();

    if (!isLoading && isLeiFelca && isFinish)
      return (
        <Navigate
          to={`${ROUTES.PROJECTS.BASE}/${ROUTES.HACKATHON.RANKING.BASE}`}
          replace
        />
      );

    return <Component {...props} />;
  };

  return Wrapper;
};

export default withLeiFelca;
